import { gql } from "@apollo/client";

export const updateAgendaShift = gql/* GraphQL */ `
mutation UpdateAgendaShift(
  $condition: ModelAgendaShiftConditionInput
  $input: UpdateAgendaShiftInput!
) {
  updateAgendaShift(condition: $condition, input: $input) {
    accepted
    confirmed
    quality
    performance
    punctuality
    deleted
    rate
    shiftId
    userId
    lat
    lng
    __typename
  }
}
`;

export const createAgendaHonor = gql/* GraphQL */ `mutation CreateAgendaHonor(
  $condition: ModelAgendaHonorConditionInput
  $input: CreateAgendaHonorInput!
) {
  createAgendaHonor(condition: $condition, input: $input) {
    createdAt
    deleted
    shift {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      performance
      punctuality
      quality
      rate
      role
      shiftAppId
      shiftId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftId
    type
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    __typename
  }
}
`;